import Vue from 'vue'
import { logger } from '~/utils/logger'
//import QdtComponent from '~/components/graph/QdtComponent.vue'

if (process.client) {
  const QdtComponent = require('~/components/graph/QdtComponent.vue').default
  logger.debug('[qdtComponent.js] QdtComponent:', QdtComponent)
  Vue.component('QdtComponent', QdtComponent)
} else {
  logger.info(
    '[qdtComponent.js] Not in client mode, skipping QdtComponent registration'
  )
}
